import { AI_API_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type { ReactElement } from 'react'
import type { RunModelResponse } from '@eggplant/types'

interface Props {
  id: string
  onSuccess: (data: RunModelResponse) => void
  children?: (data: RunModelResponse) => ReactElement
}

const GetAiRunModelRequest = ({
  id,
  onSuccess,
  children
}: Props) => {
  const url = `${AI_API_SERVICE}/runs/${id}/model`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetAiRunModelRequest
